export class DataCatalogPipelineAddressPart {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        },
        {
            "name": "pattern",
            "baseName": "pattern",
            "type": "DataCatalogPipelineAddressPartPattern",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogPipelineAddressPart.attributeTypeMap;
    }
    constructor() {
    }
}
